// pages/LandingPage.jsx
import React from 'react';
import HeroSection from '../components/landingPage/HeroSection';
import ImpactDashboard from '../components/landingPage/ImpactDashboard';
import AIInsights from '../components/landingPage/AIInsights';
import OrderManagement from '../components/landingPage/OrderManagement';
import Features from '../components/landingPage/Features';
import CTASection from '../components/landingPage/CTASection';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* You might have a Navbar here */}
      <HeroSection />
      <ImpactDashboard />
      <AIInsights />
      <OrderManagement />
      <Features />
      <CTASection />
      {/* Footer would go here */}
    </div>
  );
};

export default LandingPage;